import { URLS } from "@app/shared";

/**
 * Investor Information — Section 11 of the approved IR content sheet.
 * Titles, links and data are carried over from the beta page unchanged.
 */
export type InvestorInformationLink = {
  /** Translation key for the link label. */
  label: string;
  href: string;
};

export const quarterlyResultsLinks: InvestorInformationLink[] = [
  {
    label: "financialAnnouncements",
    href: `${URLS.investor.financialInfo}?tab=financialAnnouncements`,
  },
  {
    label: "financialStatements",
    href: `${URLS.investor.financialInfo}?tab=financialStatements`,
  },
];

/**
 * The approved design also lists "FAQs"; there is no FAQs page in the app, so
 * the row is omitted rather than rendered as a dead link.
 */
export const investorQuickLinks: InvestorInformationLink[] = [
  {
    label: "investorInformation.links.factSheet",
    href: URLS.investor.factSheet,
  },
  {
    label: "investorInformation.links.companyAnnouncements",
    href: URLS.investor.companyAnnouncements,
  },
  {
    label: "investorInformation.links.corporateGovernance",
    href: URLS.investor.governanceAndRegulatoryDocuments,
  },
  {
    label: "investorInformation.links.irContacts",
    href: URLS.investor.contactIr,
  },
];
